import {
  trigger,
  state,
  style,
  transition,
  query,
  animateChild,
} from '@angular/animations';

export const openCloseContainer = trigger('openCloseContainer', [
  state(
    'visible',
    style({
      'border-style': 'solid',
    })
  ),
  state(
    'hidden',
    style({
      'border-style': 'none',
    })
  ),
  transition('visible => hidden', [query('@openClose', animateChild())]),
]);
